import { render } from "./IconHighlightOff.vue?vue&type=template&id=0c30425e"
import script from "./IconHighlightOff.vue?vue&type=script&lang=js"
export * from "./IconHighlightOff.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__